import axios from "axios";

export default axios.create({
  baseURL: "https://api.manoshala.com",
  headers: {
    "Content-type": "application/json",
    "x-api-key": "PBIZYKGTWW6ttwJh1YWjb8eeRw53J5bctjOLmJri",
  },
});
